import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Trash2 } from "lucide-react";
import { EVENT_TYPES } from "./constants";

export function EventDialog({ open, onOpenChange, editing, form, setForm, onSave, onDelete }) {
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="event-dialog">
        <DialogHeader>
          <DialogTitle>{editing ? "Edit Event" : "Add Event"}</DialogTitle>
          <DialogDescription className="sr-only">Firm calendar event details.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label className="text-xs">Title</Label><Input data-testid="event-title" value={form.title} onChange={(e) => set("title")(e.target.value)} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs">Type</Label>
              <Select value={form.type} onValueChange={set("type")}>
                <SelectTrigger data-testid="event-type"><SelectValue /></SelectTrigger>
                <SelectContent>{EVENT_TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label className="text-xs">Date</Label><Input type="date" data-testid="event-date" value={form.date} onChange={(e) => set("date")(e.target.value)} /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs">Time</Label><Input data-testid="event-time" placeholder="9:00 AM" value={form.time} onChange={(e) => set("time")(e.target.value)} /></div>
            <div><Label className="text-xs">Owner</Label><Input data-testid="event-owner" value={form.owner} onChange={(e) => set("owner")(e.target.value)} /></div>
          </div>
          <div><Label className="text-xs">Location</Label><Input data-testid="event-location" value={form.location} onChange={(e) => set("location")(e.target.value)} /></div>
        </div>
        <DialogFooter className="flex items-center justify-between sm:justify-between">
          {editing ? <Button variant="outline" data-testid="event-delete" onClick={onDelete} className="text-destructive"><Trash2 className="h-4 w-4 mr-1.5" /> Delete</Button> : <span />}
          <Button data-testid="event-save" onClick={onSave}>{editing ? "Save Changes" : "Add Event"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
